const $ = require('jquery');

function checkBreakpoints() {
    const windowWidth = $(window).width();
    this.isInSmallFormat = this.isFormat(this.breakpoints.smallFormat, windowWidth);
    this.isInMediumFormat = this.isFormat(this.breakpoints.mediumFormat, windowWidth);
    this.isInLargeFormat = this.isFormat(this.breakpoints.largeFormat, windowWidth);
    this.isInMediumFormatGlobalHeader = this.isFormat(this.breakpoints.globalHeaderMf, windowWidth);
    this.isInCheckoutSmallFormat = this.isFormat(this.breakpoints.checkoutSm, windowWidth);
    this.currentFormat = this.getFormat();
}

// service for checking breakpoints (old browsers compatible)
// we don't sync css breakpoing for performance issues
// you need to manually change css breakpoints when you updates the javascript one
function BreakpointsService($rootScope) {
    const self = this;
    this._smallFormatBreakpoint = 768;
    this._mediumFormatCheckoutBreakpoint = 1024;
    this._mediumFormatBreakpoint = 1270;
    this._mediumFormatGlobalHeaderBreakpoint = 950;
    this._smallFormatBreakpointSm = 320;
    this._smallFormatBreakpointMd = 500;
    this._smallFormatBreakpointLg = 630;
    this._checkoutSmallFormatBreakpoint = 992;
    this.breakpoints = {
        smallFormat: {
            min: 0,
            max: this._smallFormatBreakpoint
        },
        mediumFormat: {
            min: this._smallFormatBreakpoint,
            max: this._mediumFormatBreakpoint
        },
        largeFormat: {
            min: this._mediumFormatBreakpoint,
            max: Number.MAX_VALUE
        },

        globalHeaderMf: {
            min: this._smallFormatBreakpoint,
            max: this._mediumFormatGlobalHeaderBreakpoint
        },

        checkoutSm: {
            min: 0,
            max: this._checkoutSmallFormatBreakpoint
        },

        checkoutMlf: {
            min: this._mediumFormatCheckoutBreakpoint,
            max: this._mediumFormatBreakpoint
        },
        checkoutMf: {
            min: this._smallFormatBreakpoint,
            max: this._mediumFormatCheckoutBreakpoint
        },
        checkoutSf: {
            min: 0,
            max: this._smallFormatBreakpoint
        }
    };

    this.isInSmallFormat = false;
    this.isInMediumFormat = false;
    this.isInLargeFormat = false;
    this.isInCheckoutSmallFormat = false;
    this.isInMediumFormatGlobalHeader = false;

    $rootScope.$on('window:resize', () => {
        checkBreakpoints.call(self);
    });

    checkBreakpoints.call(self);
}

BreakpointsService.prototype.isFormat = function (format, windowWidth) {
    windowWidth = windowWidth === undefined ? $(window).width() : windowWidth;

    return (format.min <= windowWidth && windowWidth <= format.max);
};

BreakpointsService.prototype.isSmallFormat = function () {
    return this.isInSmallFormat;
};

BreakpointsService.prototype.isMediumFormat = function () {
    return this.isInMediumFormat;
};

BreakpointsService.prototype.isLargeFormat = function () {
    return this.isInLargeFormat;
};

BreakpointsService.prototype.isCheckoutSmallFormat = function () {
    return this.isInCheckoutSmallFormat;
};

BreakpointsService.prototype.MediumFormatGlobalHeader = function () {
    return this.isInMediumFormatGlobalHeader;
};

BreakpointsService.prototype.getFormat = function () {
    return this.isInSmallFormat ? 'SmallFormat' : (this.isInMediumFormat ? 'MediumFormat' : 'LargeFormat');
};

BreakpointsService.prototype.getDeviceDisplayFormatString = function () {
    if (this.isInSmallFormat) {
        return 'SF';
    }
    if (this.isInMediumFormat) {
        return 'MF';
    }
    if (this.isInLargeFormat) {
        return 'LF';
    }
};

BreakpointsService.prototype.getScrollElement = function () {
    return $('html').hasClass('touch') ? $('#scroll-body') : $('html, body');
};

BreakpointsService.prototype.getScrollOffset = function () {
    return $('#header-container').outerHeight() + $('#search-bar').outerHeight();
};

BreakpointsService.prototype.scrollTop = function (duration) {
    const scrollBody = this.getScrollElement();
    scrollBody.animate({ scrollTop: 0 }, duration);
};

module.exports = BreakpointsService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/breakpoints/breakpoints-service.js
 **/